export const DragKind = {
  Move: 'move',
  Resize: 'resize',
  Create: 'create',
} as const;

export type DragKind = (typeof DragKind)[keyof typeof DragKind];

export const ResizeAnchor = {
  TopLeft: 'top-left',
  Top: 'top',
  TopRight: 'top-right',
  Right: 'right',
  BottomRight: 'bottom-right',
  Bottom: 'bottom',
  BottomLeft: 'bottom-left',
  Left: 'left',
} as const;

export type ResizeAnchor = (typeof ResizeAnchor)[keyof typeof ResizeAnchor];

export const ALL_RESIZE_ANCHORS: readonly ResizeAnchor[] = Object.values(ResizeAnchor);
